// Data: Greg Pryor career stats, book quotes, memorabilia, etc.
// Image paths reference files in /public, served at the site root.

export const ASSETS = {
  gregYankees: "/assets/greg-yankees.jpg",
  gregFielding: "/assets/greg-fielding.jpg",
  gregKids: "/assets/greg-kids.jpg",
};

export const FB_PAGE_URL = "https://www.facebook.com/GregPryor85/";

export const FB_POSTS = [
  {
    id: 1,
    when: "2 days ago",
    text: "Forty-one years ago today I made my Royals debut in spring training. Fans still send me cards from that '85 club to sign. I sign every one. Keep 'em coming.",
    likes: 318,
    comments: 47,
    shares: 22,
    tag: "MEMORY",
    permalink: "https://www.facebook.com/GregPryor85/",
    media: { type: "photo", image: "/assets/greg-yankees.jpg", extraCount: 0 },
  },
  {
    id: 2,
    when: "1 week ago",
    text: "Headed to Indian Valley last weekend to talk baseball with the kids. They asked me which was scarier — facing Nolan Ryan or signing the contract that meant I had to shave. I told them the truth.",
    likes: 642,
    comments: 89,
    shares: 41,
    tag: "EVENT",
    permalink: "https://www.facebook.com/GregPryor85/",
    media: { type: "photo", image: "/assets/greg-kids.jpg", extraCount: 0 },
  },
  {
    id: 3,
    when: "2 weeks ago",
    text: "Bret Saberhagen called me yesterday. He's still mad I didn't catch that ball in Game 7. I told him to read Chapter 11. We laughed for an hour.",
    likes: 1240,
    comments: 156,
    shares: 88,
    tag: "STORY",
    permalink: "https://www.facebook.com/GregPryor85/",
    media: { type: "photo", image: "/assets/greg-radio.jpg", extraCount: 0 },
  },
];

export const PRYOR_STATS = {
  career: {
    G: 789,
    AB: 1885,
    R: 204,
    H: 471,
    "2B": 81,
    "3B": 9,
    HR: 14,
    RBI: 146,
    BB: 96,
    AVG: ".250",
    OBP: ".289",
    SLG: ".326",
  },
  bestYears: [
    {
      year: 1979,
      team: "CHW",
      G: 143,
      AVG: ".275",
      H: 144,
      R: 64,
      RBI: 36,
      note: "Regular shortstop. Career-high in games and hits.",
    },
    {
      year: 1982,
      team: "KCR",
      G: 73,
      AVG: ".270",
      H: 49,
      RBI: 12,
      note: "First season in Kansas City. Played all 4 infield positions.",
    },
    {
      year: 1984,
      team: "KCR",
      G: 90,
      AVG: ".263",
      H: 49,
      HR: 4,
      RBI: 24,
      note: "Filled in for Brett & White. Career-best 4 HR. Royals win AL West.",
    },
    {
      year: 1985,
      team: "KCR",
      G: 50,
      AVG: ".219",
      H: 14,
      R: 8,
      note: "World Series ring. Appeared in Game 5.",
    },
  ],
  byYear: [
    { y: 1976, t: "TEX", g: 5, ab: 8, h: 3, hr: 0, rbi: 1, avg: ".375" },
    { y: 1978, t: "CHW", g: 82, ab: 195, h: 51, hr: 1, rbi: 19, avg: ".261" },
    { y: 1979, t: "CHW", g: 143, ab: 524, h: 144, hr: 1, rbi: 36, avg: ".275" },
    { y: 1980, t: "CHW", g: 122, ab: 384, h: 95, hr: 2, rbi: 32, avg: ".247" },
    { y: 1981, t: "CHW", g: 36, ab: 64, h: 14, hr: 0, rbi: 4, avg: ".219" },
    { y: 1982, t: "KCR", g: 73, ab: 181, h: 49, hr: 1, rbi: 12, avg: ".270" },
    { y: 1983, t: "KCR", g: 54, ab: 124, h: 27, hr: 1, rbi: 13, avg: ".217" },
    { y: 1984, t: "KCR", g: 90, ab: 187, h: 49, hr: 4, rbi: 24, avg: ".263" },
    { y: 1985, t: "KCR", g: 50, ab: 64, h: 14, hr: 0, rbi: 5, avg: ".219" },
    { y: 1986, t: "KCR", g: 47, ab: 100, h: 17, hr: 4, rbi: 0, avg: ".170" },
  ],
};

export const MEMORABILIA = [
  {
    id: 1,
    title: "1985 World Series Trophy",
    category: "Championship",
    year: "1985",
    size: "tall",
    img: "/assets/memorabilia/world-series-trophy.jpg",
    desc: "The replica every player on the '85 Royals got — pennants for all 26 clubs, the crown on top, our names engraved on the base. Mine sits on a bookshelf in the den. Forty-one years and the gold still hasn't dulled. Some nights I just walk past it and nod.",
  },
  {
    id: 2,
    title: "1985 Royals Championship Ring",
    category: "Championship",
    year: "1985",
    size: "lg",
    img: "/assets/memorabilia/pryor-ring.jpg",
    desc: "PRYOR across the top, the Royals crown shield in the middle, my number 4 underneath. I wore it to a card show in 1991 and a kid asked if it was real. I told him it was the most real thing I owned.",
  },
  {
    id: 3,
    title: "Signed Baseball Display",
    category: "Signed",
    year: "Various",
    size: "wide",
    img: "/assets/memorabilia/signed-baseballs-case.jpg",
    desc: "Twelve baseballs, twelve stories. Mickey Mantle. Bob Gibson. Willie Mays. George Brett with W.S. M.V.P. under his name. Two from my own first big league home runs at Comiskey in '78 — first AB, second AB, two days apart. The case stays locked. I have the only key.",
  },
  {
    id: 4,
    title: "1984 AL West Champions Plaque",
    category: "Award",
    year: "1985",
    size: "md",
    img: "/assets/memorabilia/1984-plaque.jpg",
    desc: "Handed out at the 14th Annual Kansas City Baseball Awards Dinner, January 26th, 1985. \"In recognition of outstanding individual achievements and contributions.\" I played 90 games that year. They were generous with the word 'outstanding.'",
  },
  {
    id: 5,
    title: "Team-Signed Moët",
    category: "Signed",
    year: "1985",
    size: "tall",
    img: "/assets/memorabilia/signed-moet.jpg",
    desc: "Brut Impérial. Signed by the boys after we clinched. I never opened it. My wife asks every anniversary. The answer is still no.",
  },
  {
    id: 6,
    title: "Game-Worn Pony Cleats",
    category: "Gear",
    year: "1984",
    size: "md",
    img: "/assets/memorabilia/pony-cleats.jpg",
    desc: "Made in USA. Two-tone blue, busted at the toe, the Pony tongue flap nearly torn off the right one. I wore these the season we won the West. They smell like a dugout in August. I've never had the heart to clean them.",
  },
  {
    id: 7,
    title: "Champions Weekend 2015",
    category: "Memento",
    year: "2015",
    size: "sm",
    img: "/assets/memorabilia/champions-weekend-bottle.jpg",
    desc: "Engraved bottle from the Royals' Champions Weekend — the '85 club back together to celebrate the 2015 ring. Thirty years between titles. We were grayer. The hugs were the same.",
  },
  {
    id: 8,
    title: "Wrigley Souvenir Baseball",
    category: "Memento",
    year: "1979",
    size: "sm",
    img: "/assets/memorabilia/wrigley-baseball.jpg",
    desc: "A printed-cover ball with the old ballpark on it — light towers, packed grandstand, ivy you can almost see. White Sox days. A reminder that before Kansas City, there was the South Side, and that mattered too.",
  },
  {
    id: 9,
    title: "Norman Rockwell Figurine",
    category: "Memento",
    year: "1986",
    size: "tall",
    img: "/assets/memorabilia/rockwell-figurine.jpg",
    desc: "Given to me by my dad after the World Series. Rockwell's umpire, the kids gathered around him at home plate. Dad said it reminded him of me at nine years old. I keep it on the windowsill where the morning light hits it.",
  },
  {
    id: 10,
    title: "1912 Duffy, Ohio Team",
    category: "Memento",
    year: "1912",
    size: "wide",
    img: "/assets/memorabilia/1912-team-photo.jpg",
    desc: "This is a picture of a 1912 semi-pro team in Duffy, Ohio. My grandpa Homer Pryor is in the back row, second from the left. What are the odds of having a grandpa named Homer and also hitting homers as a major leaguer?",
  },
  {
    id: 11,
    title: "1971 First Pro Contract",
    category: "Document",
    year: "1971",
    size: "tall",
    img: "/assets/memorabilia/1971-first-contract.jpg",
    desc: "The first time anybody paid me to play. Geneva of the New York-Penn League, signed June 21st, 1971 — five hundred dollars a month, six thousand to sign, and another four if I stuck around. Felt like the whole world to a kid from Orlando. A Washington Senators farm contract, the very bottom rung of the ladder. Six years of bus rides in the minors started right here. I never threw it out.",
  },
  {
    id: 12,
    title: "The Senators Welcome Letter",
    category: "Document",
    year: "1971",
    size: "tall",
    img: "/assets/memorabilia/1971-senators-welcome.jpg",
    desc: "Four days after I signed, this landed in the mailbox up in Geneva. Washington Senators letterhead, Robert F. Kennedy Stadium printed across the top, and a hearty welcome from Hal Keller, the farm director. He wished me 'success in a career with baseball.' A career — and I hadn't played a single inning of pro ball yet. The Senators packed up for Texas the very next year. I kept the letter anyway.",
  },
  {
    id: 13,
    title: "1974 Big-League Camp Invite",
    category: "Document",
    year: "1974",
    size: "tall",
    img: "/assets/memorabilia/1974-rangers-camp-invite.jpg",
    desc: "My first invitation to a big-league camp. February 1974, Texas Rangers letterhead with that cowboy-hat logo — the old Senators had become the Rangers by then. 'It gives me great pleasure on behalf of Billy Martin to invite you to the Major League spring training camp.' Pompano Beach, report February 21st, in top physical condition. They even asked the married fellas to leave the wives at home. Three years of bus rides and a big-league staff finally wanted a look. I about wore the envelope out reading it.",
  },
  {
    id: 14,
    title: "1975 Big-League Camp Invite",
    category: "Document",
    year: "1975",
    size: "tall",
    img: "/assets/memorabilia/1975-rangers-camp-invite.jpg",
    desc: "And then they asked me back. February 1975, same Rangers letterhead, same Pompano Beach, another letter from Billy Martin tucked inside. Daniel O'Brien signed this one too — vice president when he wrote me in '74, general manager by '75. 'Only signed players will be permitted in camp.' Two springs in a row getting a look from a big-league staff. In 1976 I finally made it to the majors. You hang on to the letters that got you there.",
  },
];

// Photo gallery. Like MEMORABILIA, this holds only the structural bits — the
// image path and the grid footprint. The editable copy (title, category, year,
// caption) lives in site content and is merged in by `id` in gallery.jsx, so
// Greg can rewrite any caption from the /admin console without touching code.
// Images live in /public/assets/gallery as a .jpg + same-name .webp pair.
// An entry with `video` is a video: `img` is its poster (the tile and the
// picture before it plays). Greg can also show it on his broadcasts.
// w/h: the file's pixel size (the album lays its rows out from the shape
// of each photo before it loads).
export const GALLERY = [
  { id: 1, img: "/assets/gallery/img-0463.jpg", w: 1368, h: 1106, size: "lg" },
  { id: 2, img: "/assets/gallery/img-0398.jpg", w: 1114, h: 731, size: "wide" },
  { id: 3, img: "/assets/gallery/hof-1.jpg", w: 1600, h: 1134, size: "wide" },
  { id: 4, img: "/assets/gallery/img-6421.jpg", w: 480, h: 457, size: "sm" },
  { id: 31, img: "/assets/gallery/clinch-celebration.jpg", w: 1113, h: 1500, size: "tall" },
  {
    id: 32,
    img: "/assets/gallery/rocky-asked-for-mine.jpg",
    w: 720,
    h: 1280,
    video: "/assets/gallery/rocky-asked-for-mine.mp4",
    size: "tall",
  },
  { id: 5, img: "/assets/gallery/img-0367.jpg", w: 1600, h: 1195, size: "md" },
  { id: 6, img: "/assets/gallery/img-0750.jpg", w: 445, h: 471, size: "sm" },
  { id: 7, img: "/assets/gallery/img-0496.jpg", w: 540, h: 330, size: "sm" },
  { id: 8, img: "/assets/gallery/img-0560.jpg", w: 480, h: 640, size: "tall" },
  { id: 9, img: "/assets/gallery/img-0888.jpg", w: 720, h: 1025, size: "tall" },
  { id: 10, img: "/assets/gallery/img-7060.jpg", w: 320, h: 320, size: "sm" },
  { id: 11, img: "/assets/gallery/img-2055.jpg", w: 900, h: 1600, size: "tall" },
  { id: 12, img: "/assets/gallery/img-9790.jpg", w: 1142, h: 1223, size: "tall" },
  { id: 13, img: "/assets/gallery/img-8398.jpg", w: 1278, h: 1600, size: "tall" },
  { id: 14, img: "/assets/gallery/img-0397.jpg", w: 1284, h: 1583, size: "tall" },
  { id: 15, img: "/assets/gallery/img-0129.jpg", w: 1200, h: 1600, size: "tall" },
  { id: 16, img: "/assets/gallery/img-0315.jpg", w: 1200, h: 1600, size: "tall" },
  { id: 17, img: "/assets/gallery/img-2570.jpg", w: 667, h: 994, size: "tall" },
  { id: 18, img: "/assets/gallery/img-7564.jpg", w: 626, h: 805, size: "tall" },
  { id: 19, img: "/assets/gallery/img-2047.jpg", w: 1126, h: 1504, size: "tall" },
  { id: 20, img: "/assets/gallery/img-0014.jpg", w: 1054, h: 1600, size: "tall" },
  { id: 21, img: "/assets/gallery/pine-tar-correction.jpg", w: 660, h: 495, size: "wide" },
  { id: 22, img: "/assets/gallery/img-4228.jpg", w: 423, h: 421, size: "sm" },
  { id: 23, img: "/assets/gallery/marvin-miller.jpg", w: 615, h: 405, size: "md" },
  { id: 24, img: "/assets/gallery/img-3381.jpg", w: 1242, h: 1092, size: "wide" },
  { id: 25, img: "/assets/gallery/img-2054.jpg", w: 1169, h: 681, size: "wide" },
  { id: 26, img: "/assets/gallery/img-0022.jpg", w: 1600, h: 723, size: "wide" },
  { id: 27, img: "/assets/gallery/img-0126.jpg", w: 1600, h: 1200, size: "md" },
  { id: 28, img: "/assets/gallery/img-0050.jpg", w: 1063, h: 1399, size: "tall" },
  { id: 29, img: "/assets/gallery/img-0240.jpg", w: 1251, h: 1058, size: "md" },
  { id: 30, img: "/assets/gallery/img-2061.jpg", w: 1206, h: 784, size: "md" },
];

export const TAKES = [
  {
    id: 5,
    hot: true,
    topic: "ABS / Robo Umps",
    verdict: "Long overdue.",
    body: "If a pitcher paints the corner, he ought to get the call — not lose it because the catcher framed it poorly or the ump's eyes are tired in the eighth. ABS rewards the guys who can actually pitch. I'm in.",
    reactions: 521,
    comments: 203,
  },
  {
    id: 1,
    hot: true,
    topic: "The Ghost Runner",
    verdict: "Bench it.",
    body: "The whole point of extra innings was that you earned the runner. Now we just hand them one and call it a game. Statistical fiction. Get rid of it.",
    reactions: 312,
    comments: 87,
  },
  {
    id: 2,
    hot: false,
    topic: "The Pitch Clock",
    verdict: "Keep it.",
    body: "I came up in an era where Mike Hargrove took 90 seconds between pitches. Nobody misses it. Game's crisper. I'm in.",
    reactions: 198,
    comments: 41,
  },
  {
    id: 3,
    hot: true,
    topic: "The Banned Shift",
    verdict: "Bring it back.",
    body: "If you can't pull a ground ball through a defender, that's on you. Banning the shift is babying hitters. Adapt or get demoted.",
    reactions: 412,
    comments: 156,
  },
  {
    id: 4,
    hot: false,
    topic: "Bigger Bases",
    verdict: "I'll allow it.",
    body: "Three more inches. Stolen bases are up. Game looks faster. I don't see the controversy here.",
    reactions: 89,
    comments: 22,
  },
];

export const HOT_TAKE_ROYALS = {
  date: "May 26, 2026",
  team: "Kansas City Royals",
  record: "28-24",
  take: "Two weeks ago I said Memorial Day was when the standings stop lying. Well, here we are — and we are who we thought we were. Witt is playing himself into another MVP conversation. Salvy's still squatting at 33 like the years forgot to find him. The starters are good enough. It's the bullpen that's going to decide whether June is a victory lap or a panic. Trade-deadline shopping list: a lefty arm out of the pen, and a real DH bat. Quit hoping the kid figures it out and go get the guy.",
};

export const NAV_ITEMS = [
  { id: "hero", label: "Home", index: "00" },
  { id: "book", label: "The Book", index: "01" },
  { id: "memorabilia", label: "The Collection", index: "02" },
  { id: "about", label: "About Greg", index: "03" },
  { id: "speaking", label: "On the Road", index: "04" },
  { id: "apply", label: "Sit Next To Me", index: "05" },
  { id: "mytake", label: "My Take", index: "06" },
  { id: "contact", label: "Get in Touch", index: "07" },
];

// Stills from Greg's own broadcasts for the "Greg's booth" section on the home
// page (src/components/booth.jsx): frames from the private recordings, each
// cleared by Max before it's added here (the repo is public; these four were
// cleared Oct 23 2026). jpg + webp pairs, 960x540. Dates and games from the
// recordings' Booth Notes. Empty = the row isn't shown.
export const BOOTH_STILLS = [
  {
    src: "/assets/booth/sweater-night.jpg",
    alt: "Greg in the booth in a Missoni sweater and a black cap, his White Sox and Royals jerseys behind him",
    cap: "Sweater night",
    when: "ALCS Game 6 · Oct 19",
  },
  {
    src: "/assets/booth/the-ring.jpg",
    alt: "Greg holding his 1985 World Series ring up to the camera",
    cap: "The ring, on request",
    when: "ALCS Game 5 · Oct 18",
  },
  {
    src: "/assets/booth/champions-cap.jpg",
    alt: "Greg holding up a blue World Series Champions cap",
    cap: "The 1985 champions cap",
    when: "ALCS Game 4 · Oct 17",
  },
  {
    src: "/assets/booth/howser-bobblehead.jpg",
    alt: "Greg with a Dick Howser bobblehead and its Royals box",
    cap: "Bobblehead night: Dick Howser",
    when: "ALCS Game 4 · Oct 17",
  },
];
